import React, { lazy, Suspense, useEffect } from 'react';
import { camelCaseToWords } from '../../../../utils/camelCaseToWord';
import { mappingGermanToEnglish } from '../../../../utils/mapping';
import { LoaderFallback } from '../../../shared/LoaderFallback/LoaderFallback';
import { TextCustom } from '../../../ui/TextCustom';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { rootState } from '../../../../redux/store';
import { useTranslation } from 'react-i18next';
import { Subwindow } from '../../Subwindow/Subwindow';
import { FlexCenter } from '../../FlexCenter/FlexCenter';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../constants/constants';
import { openModal } from '../../../features/Modal/modal.slice';
import { ExecButton } from '../../../ui/ExecButton/ExecButton';
import { useSendWebsocketMessage } from '../../../features/WebSocket/hooks/useSendWebsocketMessage';
import { useWebSocket } from '../../../features/WebSocket/hooks/useWebSocket';
import { IWebSocketData } from '../../../../interface/interfaces';
import { ScriptSettingsModalContent } from '../../../features/Datamanager/Inspector/ScriptSettings/ScriptSettingsModalContent';
import { Modal } from '../../../features/Modal/Modal';
import { ConfigurationWindow } from '../../../features/LauncherConfiguration/Features/ConfigurationWindow';
import { ToolConfig } from '../../../features/LauncherConfiguration/Features/ToolConfig';
import { ErrorNotification } from '../../../shared/ErrorNotification/ErrorNotification';
import IconComponent from '../../../shared/IconComponents/IconComponent';
import { Spacing } from '../../Spacing/Spacing';
import useConfigureCollectedTools from '../../../features/LauncherConfiguration/Features/hooks/useConfigureCollectedTools';
import { useMergedScripts } from '../../../features/Datamanager/Inspector/ScriptSettings/hooks/useMergedScripts';

const TreeWidget = lazy(() => import('../../../features/TreeComposite/TreeWidget/TreeWidget'));
const MemoizedTreeWidget = React.memo(TreeWidget);

export const ProjectTreePanel = () => {
    const { socketRef, isReady} = useWebSocket('Project settings');
    const { sendWebsocketMessage } = useSendWebsocketMessage(socketRef);
    const { project } = useAppSelector((state: rootState) => state.project);
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);
    const { dataAllChildrensPerNode } = useAppSelector((state: rootState) => state.filteredChildrenNodesPerSelection);

    const {selectedRadioBtn} = useAppSelector((state:rootState)=>state.treeSettingsRadioBtn)
    const { type } = useAppSelector((state: rootState) => state.avatarType);
    const {defaultProjectPath} = useAppSelector((state: rootState) => state.defaultProjectPath);




    const {
        featuresDataFilter, 
        collectedTools, 
        tools, 
        setTools, 
        index, 
        setIndex, 
        applyChanges, 
        isChecked, 
        featuresLoading, 
        featuresError, 
        userSettingsFilePath, 
        isValid, 
        error } = useConfigureCollectedTools();

    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const setDefaultProject = () => {

        const sendingWebsocketData: IWebSocketData = {
            defaultLocation: '',
            parameter: "Projektordner auswaehlen",
            data: dataAllChildrensPerNode.map((item) => item.Id),
            department: "Projektleitung",
            projectID: project?._id || '',
            token: userAndTokenData?.token || '',
        };

        sendWebsocketMessage(JSON.stringify(sendingWebsocketData))
    }




    // useEffect(()=>{
    //     if(defaultProjectPath){
    //         console.log('projectPath FROM TREE PANEL: ', defaultProjectPath)
    //     }
    // },[defaultProjectPath])
    
    return (
        <>
            <Modal modalKey="scriptSettingsModal">
                <ScriptSettingsModalContent socketRef={socketRef} isReady={isReady}/>
            </Modal>
            
            <Modal modalKey={'configureModal'}>
                {
                    featuresDataFilter.length !== 0 ? (
                        <ConfigurationWindow toolConfig={<ToolConfig collectedTools={collectedTools} tools={tools} index={index} setTools={setTools} setIndex={setIndex} />} func={applyChanges} />
                    ) : (
                        <Spacing marginSpacing={'l'} paddingSpacing={'none'}>
                            <ErrorNotification error={t('warnings.nothingToConfigure')} text={''} textSize={1.2} icon={<IconComponent size={3} iconName={'Empty list'} />} />
                        </Spacing>
                    )
                } 
            </Modal>
            <Subwindow
                hasHeaderNavigate
                isRelative={true}
                hasProjectPath={!defaultProjectPath}
                title={t('titles.project')}
                execFunc={() => dispatch(openModal("projectModal"))}
                navigateTo={()=>navigate(`/${ROUTES.PROJECTS}`)}
                headerMenu={
                    <>
                        <ExecButton stretch isDisabled={false} size="l" label={'Set project path'} showLabel={true} iconName={'Setprojectpath_data'} func={()=>setDefaultProject()} />
                        <ExecButton stretch isDisabled={false} size="l" label={'Selection mode'} showLabel={true} iconName={'Selection'} func={()=>dispatch(openModal("projectModal"))} />
                        <ExecButton stretch isDisabled={false} size="l" label={'Go to projects'} showLabel={true} iconName={'Back'} func={()=>navigate(`/${ROUTES.PROJECTS}`)} />
                    </>  
                }
                main={
                    <Suspense fallback={<LoaderFallback color={'accent-green'} label={'Creating project'} />}>
                        <MemoizedTreeWidget />
                    </Suspense>
                }
                footer={

                    <FlexCenter  direction='v' >
                        <TextCustom color="grey-dark" weight={900}>
                            {dataAllChildrensPerNode.length}
                        </TextCustom>
                        <TextCustom color="grey-dark">
                            {
                                dataAllChildrensPerNode.length !== 0
                                ?
                                    selectedRadioBtn !== 'multiple'
                                    ?
                                    `${type && mappingGermanToEnglish(camelCaseToWords(type))}`
                                    :
                                    ''
                                :
                                ''} {t('messages.projectNodesFoundNumber')}
                        </TextCustom>
                    </FlexCenter>
                }
            />
        </>

    );
};
